export const DEFAULT_PLAYER_PROPS = {
  controls: false,
  autoPlay: true,
  muted: true,
  loop: true,
  playsInline: true,
};

export const LOADING_STATUSES = {
  Initial: null,
  Loading: 1,
  Loaded: 2,
  Error: 3,
};

export const PLACEHOLDER_STATUSES = [
  LOADING_STATUSES.Initial,
  LOADING_STATUSES.Loading,
  LOADING_STATUSES.Error,
];
